import axios from "axios";
// import Swal from "sweetalert2";

const { email } = sessionStorage.getItem("sn-gestion-legal") ? JSON.parse(sessionStorage.getItem("sn-gestion-legal")) : "";

export const API = axios.create({
  baseURL: process.env.REACT_APP_HEROKU_API,
  // baseURL: "http://localhost:5000",
});

API.interceptors.request.use(function (config) {
  let user = sessionStorage.getItem("sn-gestion-legal");

  if (user) {
    const { password } = JSON.parse(user);

    config.headers["Authorization"] = "Bearer " + password;
  }

  return config;
});

API.interceptors.response.use(
  (response) => {
    return response;
  },
  (err) => {
    return err;
    // if (err.response.status === 403 || err.response.status === 401) {
    //   return Swal.fire({
    //     icon: "error",
    //     title: "Error",
    //     text: "Su sesión ha caducado",
    //     willClose: () => {
    //       sessionStorage.removeItem("sn-gestion-legal");
    //       return window.location.replace("/");
    //     }
    //   });
    // }
    // else {
    //   return err.response;
    // }
  }
);

export let requerid_info =
{
  app_id: process.env.REACT_APP_API_ID,
  access_token: process.env.REACT_APP_ACCESS_TOKEN,
  user_id: process.env.REACT_APP_USER_ID,
  notification_url: email,
  stage: "dev",
  cache: true,
  details: false,
};